import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Icon } from 'semantic-ui-react';
import restauranteroLogo from '../images/restaurantero-logo-white.png';
import { NAV_LINKS } from 'ui/navLinks';

const AppHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const isProfileActive = location.pathname.startsWith('/account');

  const handleProfileClick = () => {
    history.push('/account');
  };

  const isNavItemActive = (link) => {
    if (location.pathname.startsWith('/account')) {
      return false;
    }
    return location.pathname.startsWith(link.url);
  };

  const handleNavClick = (url) => {
    history.push(url);
  };

  return (
    <header className="app-header-bar">
      <Container>
        <div className="app-header-inner">
          <div style={{ flex: 1 }} />

          <img
            src={restauranteroLogo}
            alt="restaurantero"
            style={{
              height: '32px',
              maxWidth: '220px'
            }}
          />

          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '4px'
          }}>
            <div className="app-header-nav-desktop">
              {NAV_LINKS.map((link) => {
                const isActive = isNavItemActive(link);
                return (
                  <div
                    key={link.url}
                    role="button"
                    tabIndex={0}
                    title={link.name}
                    onClick={() => handleNavClick(link.url)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleNavClick(link.url);
                      }
                    }}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease'
                    }}
                  >
                    <Icon
                      name={link.icon}
                      size="large"
                      style={{
                        margin: 0,
                        opacity: isActive ? 1 : 0.7
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <div
              onClick={handleProfileClick}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: isProfileActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
            >
              <Icon
                name="user outline"
                size="large"
                style={{
                  margin: 0,
                  opacity: isProfileActive ? 1 : 0.7
                }}
              />
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default AppHeader;
